<template>
  <form class="adress__form">
      <div class="adress__form-block">
          <slot name="myAddresses" :mapMyAddress="mapMyAddress" />
          <slot name="top"  />
          <OverlayScrollbars>
          <div>
            <div class="adress__form-top">
              <div class="adress__title" v-if="!isOrderPage">Адрес доставки</div>
              <TheAddressSuggestionInput
                  v-show="!isOrderPage"
                  label="Улица и дом"
                  placeholder=""
                  v-model="shipping_address.custom_field.address[9]"
                  v-model:error="shippingFormErrors.shipping_address.custom_field.address[8]"
                  @selectAddress="selectAddressFromSuggestion"
                  type="text"
              />

              <AlertBox
                :is-show="isOrderPage && (shippingFormErrors.shipping_address.custom_field.address[8] || shippingFormErrors.shipping_address.custom_field.address[1])"
                message="Выберите адрес доставки"
              />

              <div class="field__form-row"  v-show="!isOrderPage">

                <div class="field__form-checkbox" v-if="!isOrderPage">
                  <input @change="saveInOrderPage" id="is_home_modal" :checked="shipping_address.custom_field.address[16]" v-model="shipping_address.custom_field.address[16]" type="checkbox" >
                  <label for="is_home_modal">Частный дом</label>
                </div>
              </div>
              <div class="field__form-row"  v-show="isOrderPage">
                <div class="field__form-checkbox" >
                  <input @change="saveInOrderPage" id="is_home_order" :checked="shipping_address.custom_field.address[16]" v-model="shipping_address.custom_field.address[16]" type="checkbox" >
                  <label for="is_home_order">Частный дом</label>
                </div>
              </div>

              <AlertBox :is-show="isShippingError && shippingErrorMessage" :message="shippingErrorMessage" />

              <div class="field__form-row">
                <TheInput
                    label="Квартира"
                    placeholder=""
                    :maxlength="9"
                    :disabled="shipping_address.custom_field.address[16]"
                    v-model="shipping_address.custom_field.address[3]"
                    v-model:error="shippingFormErrors.shipping_address.custom_field.address[3]"
                    @change="saveInOrderPage"
                    type="text"
                />
                <TheInput
                    label="Домофон"
                    placeholder=""
                    :maxlength="9"
                    :disabled="shipping_address.custom_field.address[16]"
                    v-model="shipping_address.custom_field.address[5]"
                    v-model:error="shippingFormErrors.shipping_address.custom_field.address[5]"
                    @change="saveInOrderPage"
                    type="text"
                />

              </div>

              <div class="field__form-row">
                <TheInput
                    label="Подъезд"
                    placeholder=""
                    :maxlength="9"
                    :disabled="shipping_address.custom_field.address[16]"
                    v-model="shipping_address.custom_field.address[4]"
                    v-model:error="shippingFormErrors.shipping_address.custom_field.address[4]"
                    @change="saveInOrderPage"
                    type="text"
                />
                <TheInput
                    label="Этаж"
                    placeholder=""
                    :maxlength="9"
                    :disabled="shipping_address.custom_field.address[16]"
                    v-model="shipping_address.custom_field.address[2]"
                    v-model:error="shippingFormErrors.shipping_address.custom_field.address[2]"
                    @change="saveInOrderPage"
                    type="text"
                />
              </div>

              <TheTextArea
                  :maxlength="500"
                  label="Комментарий к заказу"
                  v-model="shipping_address.custom_field.address[15]"
                  v-model:error="shippingFormErrors.shipping_address.custom_field.address[15]"
                  @change="saveInOrderPage"
              />
            </div>
            <slot name="bottom" :saveAddress="saveAddress"/>
          </div>
        </OverlayScrollbars>
      </div>
  </form>
  <div class="adress__map" v-if="showMap">
     <TheFlatMap  v-model:coordinatesProps="coordinates" :show-all-polygons="true" :show-polygons="true" @selectAddressFromSuggestion="selectAddressFromSuggestion"/>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import TheInput from "@/components/form/TheInput.vue";
import TheTextArea from "@/components/form/TheTextArea.vue";
import TheAddressSuggestionInput from "@/components/element/order/shipping/TheAddressSuggestionInput.vue";
import TheFlatMap from "@/components/element/order/shipping/TheFlatMap.vue";
import vueAutocomplete from "@venegrad/vue3-autocomplete"

import OverlayScrollbars from '@/components/element/OverlayScrollbars.vue'

export default {
  name: 'TheFlatShipping',
  props: {
    showMap: {
      default: true
    },
    isOrderPage: {
      default: false
    },
    shipping: {
      require: true
    },
  },

  components: {TheFlatMap, TheAddressSuggestionInput, TheTextArea, TheInput, vueAutocomplete, OverlayScrollbars},
  data() {
    return {
      timer: null,
      errors: {},
      coordinates: null,
      uriSelectedAddress: null,
      shipping_address: {
        custom_field: {
          address: {
            9: null, // полный адрес из подсказок
            8: null, // Улица
            1: null, // Номер дома
            3: null, // Кв./Офис
            4: null, // Подъезд
            2: null, // Этаж
            5: null, // Домофон
            6: null, // Широта
            7: null, // Долгота
            14: this.city_id, // Идентификатор города
            15: null, // Коментарий к адресу
            16: false, // Частный дом
          }
        }
      },
    }
  },
  computed:{
    hasTopSlot() {
      return !!this.$slots.top;
    },
    ...mapState({
      'city_id': state => state.city.city_id,
      'isShippingError': state => state.shipping.error,
      'shippingErrorMessage': state => state.shipping.errorMessage,
      'shippingFormErrors': state => state.shipping.formErrors,
      'isShippingLoader': state => state.shipping.isLoader,
      'checkAddressCoordinate': state => state.shipping.checkAddressCoordinate,
      'currentCity': state => state.city.currentCity,
    }),
  },
  mounted() {
    this.initFromData()
  },

  watch:{
    async 'shipping_address.custom_field.address.9'(newVal, oldVal) {
      if (
          newVal !== oldVal && this.shipping_address.custom_field.address["1"]
      ) {

        let requestCheck = null;

        if(this.uriSelectedAddress){
          requestCheck = {
            uri: this.uriSelectedAddress
          }
        }else if( this.shipping_address?.custom_field?.address?.["6"]){
          requestCheck = {
            lat: this.shipping_address.custom_field.address["6"],
            lon: this.shipping_address.custom_field.address["7"]
          }
        }
        if(requestCheck){
          requestCheck.store_id = this.currentCity?.store_id;
          await this.pointInPolygon(requestCheck).finally(()=>{
            if (!this.checkAddressCoordinate) {
              return;
            }
            if(this.checkAddressCoordinate?.lat !== this.shipping_address.custom_field.address["6"]){
              this.shipping_address.custom_field.address["6"] = this.checkAddressCoordinate.lat;
            }
            if(this.checkAddressCoordinate?.lon !== this.shipping_address.custom_field.address["7"]){
              this.shipping_address.custom_field.address["7"] = this.checkAddressCoordinate.lon;
            }
          })
        }

      }
    },
    'shipping_address.custom_field.address.6'(){
          if(
              this.shipping_address.custom_field.address["6"] &&
              this.shipping_address.custom_field.address["7"]
          ){
            this.coordinates = [parseFloat(this.shipping_address.custom_field.address["6"]), parseFloat(this.shipping_address.custom_field.address["7"]) ]
          }
    },
    'shipping_address.custom_field.address.16'(){
      if (this.shipping_address.custom_field.address["16"]) {
        Object.assign(this.shipping_address.custom_field.address, {
          2: null,
          3: null,
          4: null,
          5: null
        });
        this.resetFormErrors();
      }
    },
    shipping() {
      this.initFromData()
    }

  },
  methods:{
    ...mapMutations({
      'resetFormErrors': 'shipping/resetFormErrors',
    }),
    ...mapActions({
      'checkAddress': "shipping/checkAddress",
      'pointInPolygon': "shipping/pointInPolygon"
    }),
    async saveInOrderPage() {
      if (this.isOrderPage) {
        await this.$emit('updateShipping', 'flat.flat', this.shipping_address, true);
      }
      if(Object.keys(this.shippingFormErrors.shipping_address.custom_field.address).length === 0){
        this.resetFormErrors();
      }

    },
     async saveAddress() {
       await this.$emit('updateShipping', 'flat.flat', this.shipping_address, true);
     },
    selectAddressFromSuggestion(suggestion){
      if(suggestion === null){
        this.uriSelectedAddress = null;
        this.shipping_address.custom_field.address = {
              9: null,
              8: null,
              1: null,
              3: null,
              4: null,
              2: null,
              5: null,
              6: null,
              7: null,
              14: this.city_id,
              15: null,
              16: false,
              100: 0,
        }
        return;
      }
      this.shippingFormErrors.shipping_address.custom_field.address[100] = 0;
      this.shippingFormErrors.shipping_address.custom_field.address[9] = null;
      this.uriSelectedAddress = suggestion.uri ?? null;
      this.shipping_address.custom_field.address[9] = suggestion.showText;
      this.shipping_address.custom_field.address[8] = suggestion.street;
      this.shipping_address.custom_field.address[6] = suggestion?.coordinate?.lat ?? null;
      this.shipping_address.custom_field.address[7] = suggestion?.coordinate?.lon ?? null;
      if(suggestion.house){
        this.shipping_address.custom_field.address[1] = suggestion.house;
      }
    },
    mapMyAddress(data){
      this.shipping_address = JSON.parse(JSON.stringify(data));
    },
    initFromData(){
      this.resetFormErrors();
      if(this.shipping?.address){
        if(this.shipping?.address["16"] === ""){
          this.shipping.address["16"] = false;
        }
        this.shipping_address.custom_field.address = JSON.parse(JSON.stringify(this.shipping.address))
      }
      if(this.shipping_address.custom_field.address[14] == null){
        this.shipping_address.custom_field.address[14] = this.city_id;
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.adress__form {
  height: 100%;

  .adress__form-block {
    height: 100%;
    overflow-y: auto;
  }

  @media (max-width: 1087px) {
      height: initial;
    }
}
</style>